import lodash from 'lodash'
import * as React from 'react'
import type { Base_IContext } from '../Base/Base.IContext'
import { Base_Component } from '../Base/Base.ui.Component'
import type { DS_TData } from './DS.Data'
import { Util_shallowEqual } from '../Util/Util.shallowEqual'

interface IProps {
    selector: (Data: DS_TData) => any
    render: (value: any, context: Base_IContext) => React.ReactElement<unknown>
}

interface IState {
    value: any
}

class ListenComponent extends Base_Component<IProps, IState> {
    public data: DS_TData

    constructor(props: IProps, context: Base_IContext) {
        super(props, context)
        this.state = { value: this.selector() }
    }

    public componentDidMount() {
        this.context.dataSubscribe(this.onDataChange)
    }

    public componentWillUnmount() {
        this.context.dataUnsubscribe(this.onDataChange)
    }

    private onDataChange = () => {
        const newValue = this.selector()
        const oldValue = this.state.value
        if (Util_shallowEqual(newValue, oldValue)) return
        this.setState({ value: newValue })
    }

    private selector() {
        const value = this.props.selector(this.data)

        if (!lodash.isPlainObject(value)) {
            throw new Error("Cannot shallow compare if selector doesn't return an object")
        }

        return value
    }

    public tryRender() {
        return this.props.render(this.state.value, this.context)
    }
}

// Wrap to avoid using generics with jsx
export function DS_Listen<T>(
    selector: (d: DS_TData) => T,
    render: (value: T, context: Base_IContext) => React.ReactElement<unknown>
) {
    return <ListenComponent selector={selector} render={render} />
}
